import { useEffect } from 'react';

/**
 * Applique un <title> et une meta description spécifiques à la page courante.
 * Enregistre l'override dans window.__pageSeo pour que SiteHead (ré-appliqué sur timer
 * face aux scripts tiers qui mutent le <head>) respecte la valeur par page.
 * Réutilise la gestion centralisée des métadonnées existante (SiteHead).
 */
function upsertMeta(name, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function PageSeo({ title, description }) {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    window.__pageSeo = { title: title || null, description: description || null };
    if (title) document.title = title;
    if (description) upsertMeta('description', description);
    return () => {
      window.__pageSeo = null;
    };
  }, [title, description]);

  return null;
}
